module.exports = __webpack_public_path__ + "img/D2-g.7c833cec.jpg";